import {
  GET_MERCURIALS_ADMIN,
  GET_MERCURIAL,
} from "../../actions/mercurials/mercurials";

export default function mercurials(state = [], action) {
  switch (action.type) {
    case GET_MERCURIALS_ADMIN:
      return action.mercurials;
    case GET_MERCURIAL:
      // GET_MERCURIAL retourne un seul mercurial, on le met dans un tableau
      return action.mercurial ? [action.mercurial] : state;
    default:
      return state;
  }
}
